import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './modules/Routing/routesModule'
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom'
import './style/index.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import './share/polyfills'
import './share/config/moment'
// import './share/config/firebase'
import './share/config/sentry'
import store from './reduxStore';
import App from './app';
import { renderStaticSites } from 'src/staticSites/render';
import { unregister } from 'src/registerServiceWorker';

const root = document.getElementById('root') as HTMLElement

if (window.location.origin === process.env.REACT_APP_GMCNGINE) {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>,
    root
  );
} else {
  renderStaticSites(root)
}

unregister();
